import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28e3dbca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "validator-problems-element" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "", -1))
const _hoisted_5 = { class: "message" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "", -1))
const _hoisted_8 = { class: "message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollBox = _resolveComponent("ScrollBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (0 < _ctx.getValidationErrors.length || 0 < _ctx.getValidationWarnings.length)
      ? (_openBlock(), _createBlock(_component_ScrollBox, {
          key: 0,
          class: "scrollbox",
          alwaysShowScrollBar: true,
          scrollColor: "#1f1f1f"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getValidationErrors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "validation-result error",
                  key: error,
                  onClick: ($event: any) => (_ctx.focus(error.object))
                }, [
                  _hoisted_4,
                  _createElementVNode("p", _hoisted_5, _toDisplayString(error.reason), 1)
                ], 8, _hoisted_3))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getValidationWarnings, (warning) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "validation-result warning",
                  key: warning,
                  onClick: ($event: any) => (_ctx.focus(warning.object))
                }, [
                  _hoisted_7,
                  _createElementVNode("p", _hoisted_8, _toDisplayString(warning.reason), 1)
                ], 8, _hoisted_6))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}